module.exports = __webpack_public_path__ + "media/download2.220423b4.wav";